import { render } from "./ResultPage.vue?vue&type=template&id=507ca21d&scoped=true"
import script from "./ResultPage.vue?vue&type=script&lang=js"
export * from "./ResultPage.vue?vue&type=script&lang=js"

import "./ResultPage.vue?vue&type=style&index=0&id=507ca21d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507ca21d"]])

export default __exports__